<ng-select
  [groupBy]="$any(provider().config.groupBy)"
  [loading]="provider().loading()"
  [items]="provider().data()"
  [bindLabel]="$any(provider().config.labelKey)"
  [bindValue]="$any(provider().config.valueKey)"
  [placeholder]="placeholder()"
  [multiple]="false"
  [ngModel]="cva.value$()"
  (ngModelChange)="valueChange($event)"
  [disabled]="$any(cva.disabled$())"
  (blur)="cva.markAsTouched()"
  [appendTo]="appendTo()"
  [addTag]="addTagFn"
  [hideSelected]="!!addTagFn"
  [addTagText]="addTagText() || ('forms.select.add_item' | translate)"
  [clearable]="clearable()"
  [searchable]="searchable()"
  [typeahead]="$any(provider().supportSearch ? typeahead$ : undefined)"
  [ngClass]="'size--' + size()"
  [class.option-full-view]="optionFullView()"
  [class.borderLess]="borderLess()"
  [disabled]="disabled()"
  [dropdownPosition]="dropdownPosition()"
>
  <ng-template ng-label-tmp let-label="label" let-item="item">
    <ng-template
      [ngTemplateOutlet]="labelTemplate() || defaultLabelTemplate"
      [ngTemplateOutletContext]="{
        label: item && item[provider().config.labelKey] ? item[provider().config.labelKey] : '',
        item: item || {},
      }"
    ></ng-template>
    <ng-template #defaultLabelTemplate let-label="label" let-item="item">
      <div class="ng-select-custom-label" [class.empty-option]="!item[provider().config.valueKey]">
        {{ label }}
      </div>
    </ng-template>
  </ng-template>

  <ng-container *ngIf="!provider().config.groupBy">
    <ng-template ng-option-tmp let-searchTerm="searchTerm" let-index="index">
      <ng-template
        [ngTemplateOutlet]="optionTemplate() || defaultTemplate"
        [ngTemplateOutletContext]="{
          label:
            provider().data()[index] && provider().data()[index][provider().config.labelKey]
              ? provider().data()[index][provider().config.labelKey]
              : '',
          item: provider().data()[index],
          searchTerm: searchTerm,
        }"
      ></ng-template>
      <ng-template #defaultTemplate let-label="label" let-item="item">
        <div class="ng-select-custom-option">
          {{ label }}
        </div>
      </ng-template>
    </ng-template>
  </ng-container>

  <ng-container *ngIf="footerTemplate() as footer">
    <ng-template ng-footer-tmp>
      <ng-template [ngTemplateOutlet]="footer"></ng-template>
    </ng-template>
  </ng-container>
</ng-select>
